import { render, staticRenderFns } from "./overflow_text.vue?vue&type=template&id=236b2af8&scoped=true"
import script from "./overflow_text.vue?vue&type=script&lang=js"
export * from "./overflow_text.vue?vue&type=script&lang=js"
import style0 from "./overflow_text.vue?vue&type=style&index=0&id=236b2af8&prod&scoped=true&lang=css"
import style1 from "./overflow_text.vue?vue&type=style&index=1&id=236b2af8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236b2af8",
  null
  
)

export default component.exports